__turbopack_context__.v({
  "card": "Paper-module__w3t8hG__card",
  "root": "Paper-module__w3t8hG__root",
});
